import { useCallback, useState } from 'react'
import { CPF } from 'gerador-validador-cpf'
import { format, parse } from 'date-fns'

import { IUpdatePatientInfo, updatePatientInfo } from 'services/persons/updatePatientInfo'
import { PATIENT_HAS_SUCCESSFULLY_UPDATED_INFO } from 'settings/_storageFlagsSettings'

interface IUserUpdatePatientInfo {
  loading: boolean
  success: boolean
  errorMessage: string
  updateInfo: (data: IUpdatePatientInfo) => Promise<void>
}

export const useUpdatePatientInfo = (): IUserUpdatePatientInfo => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const updateInfo = useCallback(async({
    cpf,
    dateBirth,
    gender
  }: IUpdatePatientInfo) => {
    const parsedDate = parse(dateBirth, 'dd/MM/yyyy', new Date())

    try {
      setLoading(true)
      setErrorMessage('')
      const statusResponse = await updatePatientInfo({
        cpf: CPF.format(cpf, 'digits'), // eslint-disable-line
        dateBirth: format(parsedDate, 'yyyy-MM-dd'),
        gender,
      })

      if (statusResponse === 'OK') {
        sessionStorage.setItem(PATIENT_HAS_SUCCESSFULLY_UPDATED_INFO, 'true')
        setSuccess(true)
      }

    } catch(error) {
      setErrorMessage('Erro ao atualizar informações, tente novamente!')
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    success,
    errorMessage,
    updateInfo
  }
}